<template>
  <div class="filters list-filters" v-if="!(state.hideFilters || allFiltersDisabled(state.disabledFilters))">
    <div class="title">{{ state.Drupal.t('Filter') }}</div>
    <div class="col">
      <div class="filter" v-if="state.disabledFilters.hasOwnProperty('field_city') && !state.disabledFilters.field_city">
        <label for="place">{{ state.Drupal.t('Place of the event') }}</label>
        <select id="place" @change="updateFilter('place', $event)" :value="state.filters.place || -1">
          <option :value="-1">{{ state.Drupal.t('Everywhere') }}</option>
          <option :value="place" v-for="(place, index) in state.dictionaries.place" :key="index">{{ place }}</option>
        </select>
      </div>
      <div class="filter" v-if="state.disabledFilters.hasOwnProperty('field_event_type') && !state.disabledFilters.field_event_type">
        <label for="type">{{ state.Drupal.t('Event type') }}</label>
        <select id="type" @change="updateFilter('type', $event)" :value="state.filters.type || -1">
          <option :value="-1">{{ state.Drupal.t('All types') }}</option>
          <option :value="id" v-for="(label, id) in state.dictionaries.type" :key="id">{{ label }}</option>
        </select>
      </div>
      <div class="filter" v-if="state.regionFilterShow">
        <label for="type">{{ state.Drupal.t('Event region') }}</label>
        <select id="type" @change="updateFilter('region', $event)" :value="state.filters.type || -1">
          <option :value="-1">{{ state.Drupal.t('All regions') }}</option>
          <option :value="id" v-for="(label, id) in state.dictionaries.region" :key="id">{{ label }}</option>
        </select>
      </div>
    </div>

    <div class="col" v-if="state.disabledFilters.hasOwnProperty('field_date') && !state.disabledFilters.field_date">
      <div class="filter">
        <label for="date_from">{{ state.Drupal.t('Events from date') }}</label>
        <input type="date" id="date_from" @change="updateFilter('date_from', $event)" :value="state.filters.date_from">
      </div>
      <div class="filter">
        <label for="date_to">{{ state.Drupal.t('Events to date') }}</label>
        <input type="date" id="date_to" @change="updateFilter('date_to', $event)" :value="state.filters.date_to">
      </div>
    </div>

    <div class="col">
      <div class="filter" v-if="state.disabledFilters.hasOwnProperty('field_event_online') && !state.disabledFilters.field_event_online">
        <label for="online" @change="updateFilter('online', $event)">{{ state.Drupal.t('Available online') }}</label>
        <input type="checkbox" id="online" @change="updateFilter('online', $event)" :checked="state.filters.online">
      </div>
      <div class="filter">
        <button @click="refreshListing()">{{ state.Drupal.t('Search') }}</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Filters',
  props: ['state', 'refreshListing'],
  methods: {
    updateFilter(filter, event) {
      if (event.target.value == -1 || (event.target.type === 'checkbox' && !event.target.checked)) {
        delete this.state.filters[filter]
      } else {
        this.state.filters[filter] = event.target.type === 'checkbox' ? event.target.checked : event.target.value
      }
      this.state.changedFilters = true
    },
    allFiltersDisabled(disabledFilters) {
      let allDisabled = obj => Object.values(obj).every(v => v === true);
      return allDisabled(disabledFilters);
    }
  },
}
</script>
